(() => {
  const PRODUCT_IDS = new Set([8791019749618, 9175198761202]);
  const MAX_QUANTITY = 4;
  const MESSAGE = 'Purple Honey is limited to 4 jars per transaction.';
  const nativeFetch = window.fetch.bind(window);
  let enforcementPending = false;

  const isPurpleHoneyPath = () =>
    /\/products\/purple-honey(-qa-internal)?\/?$/.test(window.location.pathname);

  const isPurpleHoneyRow = (element) => {
    const row = element.closest(
      'cart-item, [data-cart-item], .cart-item, .ecom-cart__product-item, tr, li'
    );

    return Boolean(
      row?.querySelector(
        'a[href*="/products/purple-honey"], a[href*="/products/purple-honey-qa-internal"]'
      )
    );
  };

  const hideLegacyPurpleHoneyContent = (root = document) => {
    if (!isPurpleHoneyPath()) return;

    const legacyShippingMessages = [
      'Must pick up at our farm store.',
      'Please see our Shipped Products category.',
      'Plastic bottles for both shipping and farm pickup.',
    ];

    root.querySelectorAll('li').forEach((item) => {
      if (
        legacyShippingMessages.some((message) =>
          item.textContent.trim().startsWith(message)
        )
      ) {
        item.hidden = true;
        item.setAttribute('aria-hidden', 'true');
      }
    });
  };

  const isPurpleHoneyInput = (input) =>
    input.matches('[data-purple-honey-limit]') ||
    isPurpleHoneyRow(input) ||
    PRODUCT_IDS.has(Number(input.closest('form')?.getAttribute('product_id')));

  const clampQuantityInputs = (root = document) => {
    root.querySelectorAll('input[type="number"]').forEach((input) => {
      if (isPurpleHoneyInput(input)) {
        input.max = String(MAX_QUANTITY);

        if (Number(input.value) > MAX_QUANTITY) {
          input.value = String(MAX_QUANTITY);
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    });
  };

  const enforceCartLimit = async (notify = false) => {
    if (enforcementPending) return false;
    enforcementPending = true;

    try {
      const cart = await nativeFetch('/cart.js', {
        headers: { Accept: 'application/json' },
      }).then((response) => response.json());
      const item = cart.items.find(
        (cartItem) =>
          PRODUCT_IDS.has(Number(cartItem.product_id)) &&
          cartItem.quantity > MAX_QUANTITY
      );

      if (!item) return false;

      await nativeFetch('/cart/change.js', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ id: item.key, quantity: MAX_QUANTITY }),
      });

      if (notify) window.alert(MESSAGE);
      window.location.reload();
      return true;
    } catch (error) {
      console.error('Unable to enforce Purple Honey quantity limit.', error);
      return false;
    } finally {
      enforcementPending = false;
    }
  };

  window.fetch = async (...args) => {
    const response = await nativeFetch(...args);
    const url = String(args[0]?.url || args[0] || '');

    if (/\/cart\/(add|change|update)(\.js)?(?:\?|$)/.test(url)) {
      setTimeout(() => enforceCartLimit(true), 0);
    }

    return response;
  };

  document.addEventListener(
    'input',
    (event) => {
      const input = event.target;
      if (
        input instanceof HTMLInputElement &&
        Number(input.value) > MAX_QUANTITY &&
        isPurpleHoneyInput(input)
      ) {
        input.value = String(MAX_QUANTITY);
        window.alert(MESSAGE);
      }
    },
    true
  );

  document.addEventListener(
    'click',
    async (event) => {
      const checkout = event.target.closest(
        'button[name="checkout"], input[name="checkout"], a[href*="/checkout"]'
      );

      if (!checkout) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      if (!(await enforceCartLimit(true))) {
        window.location.assign('/checkout');
      }
    },
    true
  );

  document.addEventListener('DOMContentLoaded', () => {
    clampQuantityInputs();
    hideLegacyPurpleHoneyContent();
    if (window.location.pathname === '/cart') enforceCartLimit(true);

    new MutationObserver(() => {
      clampQuantityInputs();
      hideLegacyPurpleHoneyContent();
    }).observe(document.body, {
      childList: true,
      subtree: true,
    });
  });
})();
(() => {
  const PRODUCT_IDS = new Set([8791019749618, 9175198761202]);
  const MAX_QUANTITY = 4;
  const originalFetch = window.fetch.bind(window);
  let enforcementPromise;

  const isCartRequest = (input) => {
    const url = typeof input === 'string' ? input : input?.url || '';
    return /\/cart\/(add|change|update)(\.js)?(?:\?|$)/.test(url);
  };

  const notify = () => {
    window.alert('Purple Honey is limited to 4 jars per transaction.');
  };

  const enforceRemoteCart = async (notifyCustomer = false) => {
    if (enforcementPromise) return enforcementPromise;

    enforcementPromise = (async () => {
      const cartResponse = await originalFetch('/cart.js', {
        headers: { Accept: 'application/json' },
      });
      const cart = await cartResponse.json();
      const limitedItems = cart.items.filter(
        (item) =>
          PRODUCT_IDS.has(Number(item.product_id)) &&
          item.quantity > MAX_QUANTITY
      );

      for (const item of limitedItems) {
        await originalFetch('/cart/change.js', {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ id: item.key, quantity: MAX_QUANTITY }),
        });
      }

      if (limitedItems.length && notifyCustomer) notify();
      return limitedItems.length > 0;
    })().finally(() => {
      enforcementPromise = undefined;
    });

    return enforcementPromise;
  };

  const clampVisibleInputs = (root = document) => {
    const inputs = root.querySelectorAll(
      '[data-purple-honey-limit], form[product_id="8791019749618"] input[name="quantity"], form[product_id="9175198761202"] input[name="quantity"]'
    );

    inputs.forEach((input) => {
      input.max = String(MAX_QUANTITY);
      input.dataset.maxValue = String(MAX_QUANTITY);

      if (Number(input.value) > MAX_QUANTITY) {
        input.value = String(MAX_QUANTITY);
        input.dispatchEvent(new Event('change', { bubbles: true }));
        notify();
      }
    });
  };

  window.fetch = async (...args) => {
    const response = await originalFetch(...args);
    if (isCartRequest(args[0])) {
      enforceRemoteCart(true).catch(console.error);
    }
    return response;
  };

  document.addEventListener(
    'input',
    (event) => {
      const input = event.target.closest(
        '[data-purple-honey-limit], form[product_id="8791019749618"] input[name="quantity"], form[product_id="9175198761202"] input[name="quantity"]'
      );
      if (input && Number(input.value) > MAX_QUANTITY) {
        input.value = String(MAX_QUANTITY);
        notify();
      }
    },
    true
  );

  document.addEventListener(
    'submit',
    async (event) => {
      const submitter = event.submitter;
      if (submitter?.name !== 'checkout' && !submitter?.matches('[name="checkout"]'))
        return;

      event.preventDefault();
      const changed = await enforceRemoteCart(true).catch(() => false);
      if (changed) {
        window.location.reload();
        return;
      }
      event.target.submit();
    },
    true
  );

  document.addEventListener('DOMContentLoaded', () => {
    clampVisibleInputs();
    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) clampVisibleInputs(node);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  });
})();
